import AllEmployees from "../../../../components/company/workforce/all-employees";

export default function AllEmployeesPage(){
    return <AllEmployees/>
}